export default "__VITE_ASSET__wDZ2xyAX__"